import { Box, useToast } from '@chakra-ui/react';
import ParameterValuesFormUI from '@Modules/admin/integrationSettings/components/forms/atm/parameterValues/ParameterValuesFormUI';
import CustomSaveBtn from '@Modules/core/components/form/CustomSaveBtn';
import CustomAppModal from '@Modules/core/components/modal/CustomModal';
import CustomReactTable from '@Modules/core/components/table/CustomReactTable';
import { useMutation, useQuery } from '@tanstack/react-query';
import React from 'react';
import { getEnhancedandGABParamDataTableColumns, TEnhancedParamDataTableData } from './EnhancedandGABParamDataTableMeta';
import parameterValuesFormMeta from './parameterValuesMeta';
import fakeData from './EnhancedandGABParamFakeData'
import ParamValuesDataTableRowFormUI from '@Modules/admin/integrationSettings/components/forms/atm/parameterValues/ParamValuesDataTableRowFormUI';
import paramValuesDataTableRowFormMeta from '../../../forms/atm/paramValuesDataTableRowMeta';
import CustomTabs from '@Modules/core/components/customTab/CustomTabs';

export type TTabName = 'Paramètre amélioré' | 'Paramètre Temps';

const ParameterValuesMixedHandlers = () => {

    const [rowDataTable, setRowDataTable] = React.useState<TEnhancedParamDataTableData>({
        primaryKey: '',
        id: '',
        label: '',
        defaultValue: '',
        minValue: 0,
        maxValue: 0,
        value: 0,
    });

    const [tabName, setTabName] = React.useState<TTabName>('Paramètre amélioré');

    const editModalRef = React.useRef<any>(null);

    const formModalRef = React.useRef<{
    submitBtnRef: React.MutableRefObject<any>,
    }>(null);
    
    const toast = useToast();

    //   Initialize react Query to GET Data
    const queryKey = ["ParameterValues"];

    const {
        data,
        isLoading,
    } = useQuery({
        queryKey: queryKey,
        queryFn: async () => {
            // TODO: Replace this by your fetcher function
            return new Promise(function(resolve) {
                setTimeout(() => resolve(fakeData), 500);
            });
        },
        onSuccess: (data_: any) => {
        console.log("data_", data_);
        },
        onError: (data_: any) => {
        toast({
            position: 'top-right',
            title: "Une erreur inattendue s'est produite lors de la récupération des données",
            isClosable: true,
            status: 'error',
        });
        },
    });

    
    const { isLoading: isSubmitting } = useMutation( async() =>{}, {
        onSuccess: (data) => {
        console.log('Response: ', data);
        toast({
            position: 'top-right',
            title: 'Sauvegarde effectuée avec succès',
            isClosable: true,
            status: 'success',
        });
        },
        onError: (error) => {
        toast({
            position: 'top-right',
            title: "Une erreur inattendue s'est produite lors de l'enregistrement des données",
            isClosable: true,
            status: 'error',
        });
        console.log('Error: ', error);
        },
    });

    const onSubmit = async (payload: any) => {
        console.log('payload: ', payload);
        // TODO: Uncomment the following lines to put the logic of backend feedback operation
        /*try {
            await mutateAsync();
        } catch (error) {
            console.log(error);
        }*/
    };

    const handleEdit = (row: any, _tabName: TTabName) => {
        setTabName(_tabName);
        setRowDataTable(row.original);
        editModalRef?.current?.onOpen();
    };

    const enhancedColumns = getEnhancedandGABParamDataTableColumns({
        isLoading,
        handleEdit, tabName: 'Paramètre amélioré'
    });

    const gabColumns = getEnhancedandGABParamDataTableColumns({
        isLoading,
        handleEdit, tabName: 'Paramètre Temps'
    });

    const triggerSubmit = () => {
        formModalRef?.current?.submitBtnRef?.current?.click();
    };

    const onModalFormSubmit = async (payload: any) => {
        console.log('Modal payload: ', payload);
    };

    const tabHeaders = React.useMemo(() => ["Paramètre amélioré", "Paramètre Temps"], []);

    const tabContents = React.useMemo(() => 
        {
        // console.log("rowDataTable.primaryKey", rowDataTable.primaryKey);
        return [
            <CustomReactTable
                data={data?.enhancedParam || fakeData.enhancedParam.slice(0, 4)}
                columns={enhancedColumns} mt={6} 
            />,
            <CustomReactTable
                data={data?.gabParamValues || fakeData.gabParamValues.slice(0, 4)}
                columns={gabColumns} mt={6} 
            />,
        ]
        }
    , [data]);

    const dataTableRowMeta = tabName === 'Paramètre amélioré' ? {...paramValuesDataTableRowFormMeta} : {id: paramValuesDataTableRowFormMeta.id, label: paramValuesDataTableRowFormMeta.label, value: {...paramValuesDataTableRowFormMeta.value, type: "text"}}

    return (
        <>
            <ParameterValuesFormUI meta={parameterValuesFormMeta} onSubmit={onSubmit} isLoading={isLoading} isSubmitting={isSubmitting} />

            <Box mt={6}>
                <CustomTabs tabHeaders={tabHeaders} tabContents={tabContents} />

                <CustomAppModal
                    title="Editer"
                    ref={editModalRef}
                    actionBtn={
                        <CustomSaveBtn
                        isLoading={isLoading}
                        isSubmitting={isSubmitting}
                        onClick={triggerSubmit}
                        />
                    }
                    actionBtnText={'Valider'}
                    size="3xl"
                    isCentered
                    closeOnOverlayClick={false}
                >
                    <ParamValuesDataTableRowFormUI
                        data={rowDataTable}
                        meta={dataTableRowMeta}
                        onSubmit={onModalFormSubmit}
                        isLoading={isLoading}
                        isSubmitting={isSubmitting}
                        ref={formModalRef}
                    />
                </CustomAppModal>
            </Box>
        
        </>
    );
};

export default ParameterValuesMixedHandlers;
